import { get } from 'lodash-es';
import bosLabels from '../resources/bosLabels/index.js';
import labels from '../resources/labels/index.js';
const getLabel = (path = '', brand, ...data) => {
    const label = get(labels, path, path);
    const bosLabel = get(bosLabels, path, path);
    if (brand?.toLowerCase() === 'bos' && typeof bosLabel === 'function') {
        return bosLabel(...data);
    }
    else if (typeof label === 'function') {
        return label(...data);
    }
    if (brand?.toLowerCase() === 'bos') {
        return bosLabel;
    }
    else {
        return label;
    }
};
export default getLabel;
//# sourceMappingURL=getLabel.js.map